import script from "./LoginAttemptList.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAttemptList.vue?vue&type=script&setup=true&lang=js"

import "./LoginAttemptList.vue?vue&type=style&index=0&id=fd81f6b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd81f6b6"]])

export default __exports__